/**
 * 学习乐园 · 排排序题材包：朝代排序（paixu/pack-chaoxu.js）
 * ---------------------------------------------------------------------------
 * 每局从 14 个主干王朝里随机抽 8 个按先后排（m 选 n，池子大于局）。
 * 口径如实：只收「一统或主线上下相承」的朝代，
 * 三国之后的分裂期（西晋东晋、南北朝、五代十国）并段不单列——不然
 * 「西晋和东晋谁前谁后」考的是背诵细节而不是时间感，doc 页有说明。
 * note 是每个朝代的一句话特征——排对后在「查一查」的错位讲解和
 * 历史线的复述里都会出现，排一遍等于把朝代歌背后的故事过一遍。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.chaoxu = {
    id: 'chaoxu',
    name: '朝代排序',
    hint: '每局抽 8 个朝代排回时间线',
    cols: 4,
    draw: 8,
    winText: '夏商与西周，东周分两段；一统秦两汉……朝代歌就是这个顺序。',
    items: [
      { face: '夏', note: '史书记载的第一个王朝' },
      { face: '商', note: '甲骨文的时代' },
      { face: '西周', note: '分封诸侯，都城在镐京' },
      { face: '东周', note: '又分春秋和战国两段' },
      { face: '秦', note: '第一个大一统王朝，书同文车同轨' },
      { face: '西汉', note: '张骞通西域，丝绸之路开通' },
      { face: '东汉', note: '蔡伦改进造纸术' },
      { face: '三国', note: '魏蜀吴三足鼎立' },
      { face: '隋', note: '再造统一，开凿大运河' },
      { face: '唐', note: '贞观之治到开元盛世' },
      { face: '宋', note: '活字印刷，经济最繁荣' },
      { face: '元', note: '蒙古族建立，版图最大' },
      { face: '明', note: '郑和下西洋，今存长城多为明长城' },
      { face: '清', note: '最后一个王朝，1840 年后进入近代' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
